// components/charts/ChartStyles.js
export const chartStyles = {
  irradianceLayout: {
    title: "Irradiance vs PV Power",
    xaxis: { title: "Time" },
    yaxis: { title: "Irradiance (W/m²)", side: "left" },
    yaxis2: {
      title: "Total PV Power (kW)",
      overlaying: "y",
      side: "right",
    },
    legend: { orientation: "h", y: -0.2 },
  },
  bessLayout: {
    title: "BESS Performance Comparison",
    xaxis: { title: "Time" },
    yaxis: { title: "Value" },
    legend: { orientation: "h", y: -0.2 },
  },
  pcsPowerLayout: {
    title: "PCS Power Comparison",
    xaxis: { title: "Time" },
    yaxis: { title: "Value (kW)" },
    legend: { orientation: "h", y: -0.2 },
  },
  pcsAvailabilityLayout: {
    title: "PCS Availability Comparison",
    xaxis: { title: "Time" },
    yaxis: { title: "Available Power (kW) / Available Banks" },
    legend: { orientation: "h", y: -0.2 },
  },
  averageTempLayout: {
    title: "Average Temperature Comparison",
    xaxis: { title: "Time" },
    yaxis: { title: "Temperature (°C)" },
    legend: { orientation: "h", y: -0.2 },
  },
  enginePFLayout: {
    title: "Engine Power vs Frequency",
    xaxis: { title: "Time" },
    yaxis: { title: "Total Power (MW)", side: "left"},
    yaxis2: {
      title: "Total Frequency (Hz)",
      overlaying: "y",
      side: "right"
    },
    legend: { orientation: "h", y: -0.2}
  },
  engineAvailabilityLayout: {
    title: "Engine Availability",
    xaxis: { title: "Time" },
    yaxis: { title: "Available Power (MW) / Available Banks" },
    legend: { orientation: "h", y: -0.2 }
  },
  engineFuelLayout: {
    title: "Engine Fuel Consumption",
    xaxis: { title: "Time" },
    yaxis: { title: "Fuel Consumption (L/h)" },
    legend: { orientation: "h", y: -0.2 }
  },
  IrradiancePOA: {
    title: "Plane of Array Irradiance",
    xaxis: { title: "Time" },
    yaxis: { title: "Irradiance (W/m²)" },
    legend: { orientation: "h", y: -0.2 },
  },
  horizontalIrradianceLayout: {
    title: "Horizontal Irradiance",
    xaxis: { title: "Time" },
    yaxis: { title: "Irradiance (W/m²)" },
    legend: { orientation: "h", y: -0.2 },
  },
  moduleTemperatureLayout: {
    title: "Module Temperature",
    xaxis: { title: "Time" },
    yaxis: { title: "Temperature (°C)" },
    legend: { orientation: "h", y: -0.2 },
  },
  windSpeedLayout: {
    title: "Wind Speed",
    xaxis: { title: "Time" },
    yaxis: { title: "Speed (m/s)" },
    legend: { orientation: "h", y: -0.2 },
  },
  pressureLayout: {
    title: "Barometric Pressure",
    xaxis: { title: "Time" },
    yaxis: { title: "Pressure (hPa)" },
    legend: { orientation: "h", y: -0.2 },
  },
  dualAxisEnergyLayout: {
    title: "Energy Produced Today vs Total Energy",
    xaxis: { title: "Time" },
    yaxis: { title: "Energy Produced Today (kWh)", side: "left" },
    yaxis2: {
      title: "Total Energy (kWh)",
      overlaying: "y",
      side: "right",
    },
    legend: { orientation: "h", y: -0.2 },
  },
  voltageFrequencyLayout: {
    title: "Voltage & Frequency Trends",
    xaxis: { title: "Time" },
    yaxis: { title: "Voltage", side: "left" },
    yaxis2: {
      title: "Frequency (Hz)",
      overlaying: "y",
      side: "right",
    },
    legend: { orientation: "h", y: -0.2 },
  },
  // pv
  pvPowerLayout: {
    title: "PV Power Output",
    xaxis: { title: "Time" },
    yaxis: { title: "Power (kW)" },
    legend: { orientation: "h", y: -0.2 },
  },
  pvSpecificLayout: {
    title: "PV Specific Metric",
    xaxis: { title: "Time" },
    yaxis: { title: "Value" },
    legend: { orientation: "h", y: -0.2 },
  },
  moduleAverageTempLayout: {
    title: "Module Average Temperature",
    xaxis: { title: "Time" },
    yaxis: { title: "Temperature (°C)" },
    legend: { orientation: "h", y: -0.2 },
  },
  pvAvailabilityLayout: {
    title: "PV Availability",
    xaxis: { title: "Time" },
    yaxis: { title: "Availability (%)" },
    legend: { orientation: "h", y: -0.2 },
  },
  sitePowerLayout: {
    title: "Site Power Overview",
    xaxis: { title: "Time" },
    yaxis: { title: "Power (kW)" },
    legend: { orientation: "h", y: -0.2 },
  },
  pcsAvalabilityLayout: {
    title: "PCS Availability Comparison",
    xaxis: { title: "Time" },
    yaxis: { title: "Available Power (kW) / Available Banks" },
    legend: { orientation: "h", y: -0.2 },
  },
  // Add more chart styles as needed
};
